const BACKEND_URL = 'https://admin.mediabase.sk';
// const BACKEND_URL = 'https://admin.mediabase.sk/app_dev.php';
// const BACKEND_URL = 'http://localhost:8080/web/app_dev.php';

const API_URL = `${BACKEND_URL}/api`;
const GRAPHQL_URL = `${BACKEND_URL}/graphql/`;

const STATIC_URL = 'https://static.mediabase.sk/';

export { API_URL, GRAPHQL_URL, STATIC_URL };